import { GridApi } from "ag-grid-enterprise";
import { TColumnType, TSaveColumnState } from ".";

export const UtilColumnConfig = {
  getColumnStateFromGrid: (props: {
    gridRef?: {
      api: GridApi<any>;
    };
  }) => {
    const { gridRef } = props;
    const sortedColArr = [] as Array<TColumnType>;
    const colFilters = gridRef?.api?.getFilterModel();

    gridRef?.api.getColumnState()?.forEach((col, index) => {
      const colKey = col.colId || "";
      const colDef = gridRef?.api.getColumnDef(colKey);

      if (colFilters && col && colDef && !colDef.suppressColumnsToolPanel) {
        const agFilter = colFilters[colKey];

        const field = {
          name: colKey,
          agFilter: agFilter ? JSON.stringify(agFilter) : null,
          filter: null,
          sortOrder: col.sort || null,
          range: null,
          width: col?.width ? Math.round(col.width) : null
        };

        sortedColArr.push({
          order: index + 1,
          field,
          visibility: colDef?.lockVisible || !col.hide
        });
      }
    });

    return {
      columnList: sortedColArr,
      quickSearch: ""
    };
  },

  setFilterStateFromData: (props: {
    columnStates: TSaveColumnState;
    gridRef?: {
      api: GridApi<any>;
    };
  }) => {
    const { columnStates, gridRef } = props;
    if (!columnStates) return;
    const { columnList } = columnStates;
    gridRef?.api.setFilterModel(null);
    const filterstate: any = {};
    const checkBoxColumnId = "ag-Grid-SelectionColumn";

    if (columnList?.length > 0) {
      const columnState = gridRef?.api
        ?.getColumnState()
        ?.map((column: any) => {
          const colDef = gridRef?.api.getColumnDef(column.colId);
          if (colDef?.suppressColumnsToolPanel) return null;

          const colKey = column?.colId || "";
          if (colKey === checkBoxColumnId) {
            return { ...column, order: -1 }; // It Should be first
          }
          const col1 = columnList?.find((cols) => cols.field.name === colKey);

          if (!col1) {
            return { ...column, hide: true }; // Hide if not found in saved columns
          }

          const filter = col1?.field.filter;
          if (filter) {
            const range = { ...col1?.field?.range };
            if (range) {
              range.to = Number(range.to);
              range.from = Number(range.from);
            }
            filterstate[colKey] = {
              values: filter || null,
              filterType: "set",
              range
            };
          } else if (col1?.field.agFilter) {
            filterstate[colKey] = JSON.parse(col1.field.agFilter);
          }

          const gridCol = { ...column };
          gridCol.hide = !colDef?.lockVisible && !col1?.visibility;
          gridCol.order = col1?.order;
          gridCol.sort = col1?.field.sortOrder;
          gridCol.width = col1?.field?.width;
          return gridCol;
        })
        .filter((c) => c);

      if (columnState) {
        const sortedArr = columnState?.sort((a, b) => a.order - b.order);
        gridRef?.api.applyColumnState({
          state: sortedArr,
          applyOrder: true
        });

        if (Object.keys(filterstate).length > 0) {
          setTimeout(() => {
            gridRef?.api?.setFilterModel(filterstate);
          }, 0);
        } else {
          gridRef?.api.onFilterChanged();
        }
      }
    }
  },

  setFilterStateFromDataForSubmittalLog: (props: {
    columnStates: TSaveColumnState;
    gridRef?: {
      api: GridApi<any>;
    };
  }) => {
    const { columnStates, gridRef } = props;
    if (!columnStates) return;
    const { columnList } = columnStates;
    gridRef?.api.setFilterModel(null);
    const filterstate: any = {};
    const checkBoxColumnId = "ag-Grid-SelectionColumn";

    const defaultColIds = ["action"];

    if (columnList?.length > 0) {
      const columnState = gridRef?.api
        ?.getColumnState()
        ?.map((column: any) => {
          const colKey = column?.colId || "";
          if (colKey === checkBoxColumnId) {
            return { ...column, order: -1 }; // It Should be first
          }
          const colDef = gridRef?.api.getColumnDef(column.colId);
          const col1 = columnList?.find((cols) => cols.field.name === colKey);

          if (defaultColIds.includes(colKey)) {
            return { ...column, hide: false };
          }

          if (!col1) {
            return { ...column, hide: true };
          }

          const filter = col1?.field.filter;
          if (filter) {
            const range = { ...col1?.field?.range };
            if (range) {
              range.to = Number(range.to);
              range.from = Number(range.from);
            }
            filterstate[colKey] = {
              values: filter || null,
              filterType: "set",
              range
            };
          } else if (col1?.field.agFilter) {
            filterstate[colKey] = JSON.parse(col1.field.agFilter);
          }

          const gridCol = { ...column };
          gridCol.hide = !colDef?.lockVisible && !col1?.visibility;
          gridCol.order = col1?.order;
          gridCol.sort = col1?.field.sortOrder;
          gridCol.width = col1?.field?.width;
          return gridCol;
        })
        .filter((c) => c);

      if (columnState) {
        const sortedArr = columnState?.sort((a, b) => a.order - b.order);
        gridRef?.api.applyColumnState({
          state: sortedArr,
          applyOrder: true
        });

        if (Object.keys(filterstate).length > 0) {
          setTimeout(() => {
            gridRef?.api?.setFilterModel(filterstate);
          }, 0);
        } else {
          gridRef?.api.onFilterChanged();
        }
      }
    }
  }
};
